import React from "react";
import BaseText from "../BaseText";
import TextProps, { TextType } from "../interface";

function H6({ children, customAs, ...props }: TextProps): React.ReactElement {
  return (
    <BaseText as={customAs ? customAs : "h6"} type={TextType.H6} {...props}>
      {children}
    </BaseText>
  );
}

export default H6;
